<template>
  <div>
    <!--头部-->
    <header class="header">
      <div class="logo">
        <div class="logoImg"></div>
      </div>
      <ul class="list">
        <li class="title ">首页</li>
        <li class="title">关于我们</li>
        <li class="title">后期全流程</li>
        <li class="title">作品展示</li>
        <li class="title">公司动态</li>
        <li class="title">加入我们</li>
      </ul>
      <div class="mail">
        <div class="mailText">E-mail
          <div class="mailIcon"><img src="" alt=""></div>
        </div>

      </div>
    </header>
    <!--轮播-->
    <div class="swiper">
      <swiper ref="mySwiper" :options="swiperOptions" @slideChange="slideChange" class="banner">
        <swiper-slide class="item one"><img src="../assets/img01.jpg" alt=""></swiper-slide>
        <swiper-slide class="item two"><img src="../assets/img01.jpg" alt=""></swiper-slide>
        <swiper-slide class="item three"><img src="../assets/img01.jpg" alt=""></swiper-slide>
        <swiper-slide class="item four"><img src="../assets/img01.jpg" alt=""></swiper-slide>
        <swiper-slide class="item five"><img src="../assets/img01.jpg" alt=""></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!--工作-->
    <div class="work">
      <div class="video"></div>
      <div class="video"></div>
      <div class="video"></div>
      <div class="video"></div>
      <div class="video"></div>
      <div class="video"></div>
    </div>
    <!--主体-->
    <div class="subject">
      <div class="film">
        <div class="workTitle">
          <div class="titleLeft"></div>
          <div class="titleRight"></div>
        </div>
        <div class="workspan"></div>
        <div class="workGoods">
          <div class="good">
            <div class="goodImg"></div>
            <div class="goodTitle">《生活万万岁》</div>
          </div>
          <div class="good"></div>
          <div class="good"></div>
          <div class="good"></div>
        </div>
      </div>
      <div class="tv"></div>
      <div class="network"></div>
    </div>
    <!--关于我们-->
    <div class="aboutUs">
      <div class="aboutTitle">
        <div class="titleLeft"></div>
      </div>
      <div class="aboutBody">
        <div class="aboutImg"><img src="" alt=""></div>
        <div class="aboutText">
          <div class="textTitle">我们是一家专业的全流程影视后期制作公司</div>
          <div class="textBox">
            我们专业从事影视后期制作，是目前国内规模最大的民营影视制作公司之一，拥有杜比认证的DOBLY ATMOS ™电影全景声终混棚及
            HDR DOBLY VISON™调色棚。现有营业面积3000多平方米，现有员工两百余人，拥有国内顶级的成熟后期制作团队为客户的需求提
            供专业服务；强大的软硬件支持，实现了影视后期的“一站式全流程”服务，实现了影视生产的“高效率、高覆盖、高安全”。随着成功
            作品的不断推出，在业内获得了高度认可，我们成为了国内影视后期制作标准的缔造者之一。
          </div>
        </div>
      </div>
    </div>
    <!--底部-->
    <footer>
      <div class="footLogo">
        <img src="../assets/img01.jpg" alt="">
      </div>
      <div class="more">
        <div class="moreTextBox">
          <div class="moreText">作品展示</div>
          <div class="moreText">获奖经历</div>
          <div class="moreText">加入我们</div>
          <div class="moreText">商务合作</div>
        </div>
        <div class="moreBottom">
          <span>北京市朝阳区日坛北路日坛国际贸易中心</span><span>Fax:  8610-62063551</span><span>Tel：8610-62062811</span></div>
      </div>
      <div class="ma">
        <div class="weixin">
          <div class="weixinMa"><img src="../assets/img01.jpg" alt=""></div>
          <div class="maText">官方微信</div>
        </div>
        <div class="weibo">
          <div class="weiboMa"><img src="../assets/img01.jpg" alt=""></div>
          <div class="maText">新浪微博</div>
        </div>
      </div>
      <div class="beiAn">备案号：2738473929热4878</div>
    </footer>
  </div>

</template>

<script>
  import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'

  export default {
    name: "Home",
    components: {
      Swiper,
      SwiperSlide
    },
    directives: {
      swiper: directive
    },
    data() {
      return {
        swiperOptions: {
          pagination: {
            el: '.swiper-pagination',
            bulletClass: 'my-bullet',
            bulletActiveClass: 'my-bullet-active',
          },
          loop: true,
          slidesPerView: 3,//页面可视数（网格）
          autoplay: {  //自动播放
            delay: 3000,
          },
          centeredSlides: true, //active slide会居中
          centeredSlidesBounds: true,//当设置了Active Slide居中后，还可以配合设置此参数，使得第一个和最后一个Slide 始终贴合边缘
          slideToClickedSlide: true,//点击slide显示当前的slide
          effect: 'coverflow',
          coverflowEffect: {
            rotate: 0,//slide做3d旋转时Y轴的旋转角度。默认50。
            stretch: 10,//每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
            depth: 350,//slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
            modifier: 1,//depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
            slideShadows: true,//开启slide阴影。默认 true。
          },
        },

      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    methods: {
      slideChange() {
        console.log("当前index", this.swiper.activeIndex);
      }
    },
    mounted() {
      console.log('Current Swiper instance object', this.swiper)
      console.log(1234567)
      // this.swiper.slideTo(3, 4000, false)
    }
  }
</script>
<style>

  .my-bullet {
    width: 20px;
    height: 20px;
    display: inline-block;
    border: #ffffff 1px solid;
    border-radius: 100%;
    margin-right: 20px;
  }

  .my-bullet-active {
    background-color: #D20617;
    opacity: 1;
  }
</style>
<style scoped>
  .header {
    width: 100%;
    height: 138px;
    background: #05060A;
  }

  .logo {
    width: 381px;
    height: 100%;
    float: left;
    padding-top: 40px;
    box-sizing: border-box;
  }

  .mail {
    width: 381px;
    height: 100%;
    background: antiquewhite;
    float: right;
  }

  .mailText {
    width: 120px;
    height: 100%;
    line-height: 138px;
    text-align: left;
    font-size: 20px;
    color: #ffffff;
    background-color: red;
    margin: 0 auto;
    position: relative;
    cursor: pointer;
  }

  .mailIcon {
    width: 28px;
    height: 21px;
    background-color: yellow;
    position: absolute;
    right: 0;
    top: 57px;
  }

  .mailIcon img {
    width: 100%;
    height: 100%;
  }

  .logoImg {
    width: 209px;
    height: 51px;
    background: #D20617;
    margin-left: 141px;
  }

  .list {
    float: left;
    width: 1000px;
    height: 100%;
  }

  .title {
    width: 165px;
    height: 100%;
    float: left;
    color: #ffffff;
    font-size: 21px;
    text-align: center;
    line-height: 138px;
    cursor: pointer;
  }
  /*.titleHot{
    font-size: 24px;
    background-color: #D20617;
  }*/
  .swiper {
    width: 100%;
    height: 933px;
    background-color: #202020;
  }

  .banner {
    width: 100%;
    height: 930px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .item img {
    width: 100%;
    height: 100%;
  }

  /*.swiper-pagination-bullet{*/
  /*  width: 20px;*/
  /*  height: 20px;*/
  /*  border: #ffffff 1px solid;*/
  /*  background: none;*/
  /*}*/
  .work {
    width: 100%;
    height: 862px;
    background-color: #0F0F0F;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 75px 0;
    box-sizing: border-box;
  }

  .video {
    width: 542px;
    height: 348px;
    background-color: red;
    border: 1px solid #000000;
    box-sizing: border-box;
    margin: 0 4px;
  }

  .subject {
    width: 100%;
  }

  .film {
    width: 100%;
    height: 878px;
    background: #0F0F0F;
  }

  .workTitle {
    width: 100%;
    height: 154px;
    border-top: 2px solid #666666;
    box-sizing: border-box;
    position: relative;
  }

  .workspan {
    width: 100%;
    height: 2px;
    background-image: linear-gradient(to right, #666666, #202020, #0F0F0F);
  }

  .titleLeft {
    width: 200px;
    height: 60px;
    background: #E60619;
    float: left;
    margin-left: 140px;
    margin-top: 46px;
  }

  .titleRight {
    width: 56px;
    height: 11px;
    background: #D20617;
    position: absolute;
    right: 140px;
    bottom: 42px;
  }

  .workGoods {
    width: 100%;
    height: 724px;
    display: flex;
    justify-content: space-between;
    padding: 79px 142px 0 142px;
    box-sizing: border-box;
  }

  .good {
    width: 309px;
    height: 550px;
    background: mediumblue;
  }

  .goodImg {
    width: 309px;
    height: 431px;
    background: #D20617;
    margin-bottom: 95px;
  }

  .goodTitle {
    width: 100%;
    height: 24px;
    background: #D20617;
    font-size: 24px;
    color: #ffffff;
    text-align: center;
    line-height: 24px;
  }

  .aboutUs {
    width: 100%;
    height: 980px;
    background: #0F0F0F;
  }

  .aboutTitle {
    width: 100%;
    height: 154px;
    border-top: 2px solid #666666;
    box-sizing: border-box;
    position: relative;
  }

  .aboutBody {
    width: 100%;
    height: 810px;
    background: #0F0F0F;
    padding-top: 71px;
  }

  .aboutImg {
    width: 1644px;
    height: 398px;
    margin: 0 auto;
    background: yellow;
  }

  .aboutImg > img {
    width: 100%;
    height: 100px;
  }

  .aboutText {
    width: 1230px;
    height: 200px;
    margin: 71px auto;
  }

  .textTitle {
    width: 100%;
    height: 40px;
    font-size: 32px;
    text-align: center;
    color: #ffffff;
    margin-bottom: 30px;
  }

  .textBox {
    width: 100%;
    height: auto;
    font-size: 21px;
    color: #ffffff;
    line-height: 30px;
    text-align: left;
  }

  footer {
    width: 100%;
    height: 507px;
    background: #0F0F0F;
    border-top: 2px solid #BFBFBF;
    padding: 190px 140px 0 140px;
    box-sizing: border-box;
    position: relative;
  }

  .footLogo {
    width: 302px;
    height: 72px;
    background: #D20617;
    float: left;
  }

  .footLogo img {
    width: 100%;
    height: 100%;
  }

  .more {
    width: 1050px;
    height: 150px;
    float: left;
  }

  .moreTextBox {
    width: 100%;
    height: 72px;
    padding: 0 100px;
    box-sizing: border-box;
  }

  .moreText {
    width: 210px;
    height: 72px;
    color: #ffffff;
    float: left;
    font-size: 21px;
    text-align: center;
    line-height: 72px;
  }

  .moreBottom {
    width: 100%;
    height: 20px;
    margin-top: 40px;
  }

  .moreBottom span {
    font-size: 18px;
    line-height: 18px;
    color: #666666;
    margin: 0 20px;
  }

  .ma {
    width: 250px;
    height: 150px;
    float: right;
  }

  .weixin, .weibo {
    width: 88px;
    height: 150px;
    float: right;
    margin-left: 33px;
  }

  .weixinMa, .weiboMa {
    width: 88px;
    height: 88px;
  }

  .weixinMa img, .weiboMa img {
    width: 100%;
    height: 100%;
  }

  .maText {
    width: 100%;
    height: 18px;
    font-size: 18px;
    line-height: 18px;
    color: #ffffff;
    text-align: center;
    margin-top: 20px;
  }

  .beiAn {
    width: 100%;
    height: 18px;
    position: absolute;
    left: 0;
    bottom: 45px;
    text-align: center;
    color: #666666;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue